import React, {  useRef, useContext } from 'react';
import {  Button, Box, Grid } from '@mui/material';
import { Formik, Form } from 'formik';
import * as Yup from 'yup'
import symptomHandler from '../../../utilities/symptomHandler';
import RadioButton from '../symptoms/Symptom Modal/radiobutton';
import CheckboxGroup from '../symptoms/Symptom Modal/checkboxgroup';
import InputField from '../symptoms/Symptom Modal/inputfield';
import TextArea from '../symptoms/Symptom Modal/textarea';
import DropDown from '../symptoms/Symptom Modal/dropdown';
import { SymptomDetailsContext } from '../../../utilities/context';
import reportUtils from '../../../utilities/report/reportutils';

function InvestigationExtraQuestionsForm (props){

const {setInvestigationQuestions} = useContext(SymptomDetailsContext) 
let initialValues={}
const formValues=useRef()
const validationSchema =  Yup.object(reportUtils.buildValidationsSchema(props.questions))

const onSubmit=(values)=>
   {
    setInvestigationQuestions(values)
    props.setSubmitted(true)
    props.handleClose()
   }

const getInitialValues=()=>
  {
  props.questions.forEach((question)=>
  {
    initialValues[(question.label.replaceAll(" ","_"))]=""
  })
}

getInitialValues()


const onChange=(symptom,element)=>{
initialValues[symptom]=element}
//questions refered to "symptom" in iterator to allow reuse fo previous code
let formQuestions =[]
if (props.questions.length>0)
  {
  formQuestions=props.questions.map((symptom, index)=>
      { 
        symptom["name"]=symptom.label.replaceAll(" ","_")
     
  switch(symptom["controlType"])
      {
        case "radio button":
          let gridSize = 4
          if (symptom.options.length >5)
            {gridSize = 12} 
            let gridSizeMed=5
          symptom["optionObject"]=symptomHandler.ListOptions(symptom.options, "checkbox")
        return (<Grid item  sm={12} md ={gridSizeMed} lg={gridSize}  key={index}> <RadioButton  symptom={symptom}  onChange={onChange} key={0} /> </Grid>)

        case "number":
        return (<Grid item xs={6} sm={4} key={index}> <InputField type={"number"} symptom ={symptom} min={"0"} key={0} /> </Grid>)

        case "text":
        return (<Grid item xs={5} sm={3} key={index}> <InputField type={"text"} symptom ={symptom}  key={0} /> </Grid>)

        
        case "text area":
        return (<Grid item xs={12} sm={6} key={index}> <TextArea  symptom ={symptom}  key={0} /> </Grid>)
        
        case "dropdown": 
        symptom["optionObject"]=symptomHandler.ListOptions(symptom.options, "dropdown")
        return(<Grid item xs={5} sm={3} key={index}> <DropDown  symptom ={symptom}  key={0} /> </Grid>)

        case "checkbox group":
          let gridSizeCb = 4
          if (symptom.options.length >5)
            {gridSizeCb = 12} 
            let gridSizeCbMed=5
          symptom["optionObject"]=symptomHandler.ListOptions(symptom.options, "checkbox")
          return (<Grid item  sm={12} md ={gridSizeCbMed} lg={gridSizeCb} key={index}> <CheckboxGroup symptom={symptom}  key={0} /> </Grid>)

          case "checkbox group extra wide":
          symptom["optionObject"]=symptomHandler.ListOptions(symptom.options, "checkbox")
          return (<Grid item  xs={12} key={index}> <CheckboxGroup symptom={symptom}  key={0} /> </Grid>)


        case "date":
        return (<Grid item xs={5} sm={4} key={index}> <InputField type={"date"} symptom ={symptom}  key={0} /> </Grid>)

        default:{return(<></>)}
  }
  })
}
  
return(

        <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
        innerRef={formValues}
        >
       <Form>
           
        <Box >
        <Grid container >
        {formQuestions}
         <Button sx={{ m: 1 }} variant='contained' size="small" type='submit'>Submit</Button>
       </Grid> 
       </Box>
       
        
        </Form>
      </Formik>

)



}
export default InvestigationExtraQuestionsForm